<template>
  <modal-component
    :is-displayed="isSelectorModalOpened"
    @toggle-modal="$emit('toggle-modal')"
  >
    <div v-if="isLoading" class="flex w-full justify-center">
      <small-loader />
    </div>
    <div v-else class="flex">
      <div class="flex-1 px-6">
        <h1 class="pb-4 text-xl font-bold">{{$t('SidebarMenu.ParkingSpaces')}}</h1>
        <dx-tree-view
          id="parking-space-treeview"
          :items="parkingSpaceFilterStore.parkingSpaceTreeList"
          :select-nodes-recursive="true"
          data-structure="plain"
          display-expr="label"
          key-expr="id"
          parent-id-expr="categoryId"
          selection-mode="multiple"
          show-check-boxes-mode="selectAll"
          @selection-changed="onSelectionChangedSpaces"
        />
      </div>
      <div v-if="digitalParkingSignsStore.digitalParkingSignsTreeList.length > 0" class="flex-1 px-6">
        <h1 class="pb-4 text-xl font-bold">{{$t('SidebarMenu.ParkingSigns')}}</h1>
        <dx-tree-view
          id="parking-displays-treeview"
          :items="digitalParkingSignsStore.digitalParkingSignsTreeList"
          :select-nodes-recursive="true"
          data-structure="plain"
          display-expr="label"
          key-expr="id"
          selection-mode="multiple"
          show-check-boxes-mode="selectAll"
          @selection-changed="onSelectionChangedDisplays"
        />
      </div>
    </div>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import { DigitalParkingSigns, ParkingSpaceTree } from "@/modules/Parkom/Services/DashboardTypes";
import { useToast } from "vue-toastification";
import DashboardService from "@/modules/Parkom/Services/DashboardService";
import SmallLoader from "@/core/Components/SmallLoader.vue";
import DxTreeView from "devextreme-vue/tree-view";
import DevExpress from "devextreme";
import dxTreeView from "devextreme/ui/tree_view";
import { useParkingSpaceFilterStore } from "@/core/Store/useParkingSpaceFilterStore";
import EventInfo = DevExpress.events.EventInfo;
import { useDigitalParkingSigns } from "../Store/useDigitalParkingSigns";

export default defineComponent({
  components: { SmallLoader, ModalComponent, DxTreeView },
  props: {
    isSelectorModalOpened: Boolean,
  },
  emits: ["toggle-modal"],
  data() {
    return {
      dashboardService: new DashboardService(),
      parkingSpaceFilterStore: useParkingSpaceFilterStore(),
      digitalParkingSignsStore: useDigitalParkingSigns(),
      toast: useToast(),
      isLoading: false,
      tempParkingSpaceIds: [] as number[],
      tempDisplaysIds: [] as number[],
    };
  },
  unmounted() {
    this.parkingSpaceFilterStore.selectedParkingSpaceIds =
      this.tempParkingSpaceIds;
    this.digitalParkingSignsStore.selectedDigitalParkingSignsIds =
      this.tempDisplaysIds;
  },
  mounted() {
    this.tempParkingSpaceIds =
      this.parkingSpaceFilterStore.selectedParkingSpaceIds;
    this.tempDisplaysIds = this.digitalParkingSignsStore.selectedDigitalParkingSignsIds;
  },
  methods: {
    async getParkingSpaceTreeList() {},
    onSelectionChangedSpaces(e: EventInfo<dxTreeView>) {
      const selectedParkingSpaces = e.component
        .getSelectedNodes()
        .map((x) => x.itemData) as ParkingSpaceTree[];

      this.tempParkingSpaceIds = selectedParkingSpaces
        .filter((x) => !!x.spaceId)
        .map((x) => x.spaceId);
    },
    onSelectionChangedDisplays(e: EventInfo<dxTreeView>) {
      const selectedDisplays = e.component
        .getSelectedNodes()
        .map((x) => x.itemData) as DigitalParkingSigns[];

      this.tempDisplaysIds = selectedDisplays
        .filter((x) => !!x.displayId)
        .map((x) => x.displayId);
    },
  },
});
</script>

<style scoped></style>
